import { useEffect } from "react";
import { Helmet } from "react-helmet";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import WhyChooseUs from "../components/WhyChooseUs";
import CoreServices from "../components/CoreServices";
import HowWeWork from "../components/HowWeWork";
import Stats from "../components/Stats";
import PortfolioOptimized from "../components/PortfolioOptimized";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import BackToTopButton from "../components/BackToTopButton";
import FloatingSocialButtons from "../components/FloatingSocialButtons";
import Testimonials from "../components/Testimonials";
import WeAreHiring from "../components/WeAreHiring";
import Newsletter from "../components/Newsletter";

const Index = () => {
  useEffect(() => {
    document.title = "DG IT Pvt. Ltd. - Creative Digital Agency in Nepal";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Helmet>
        <meta name="description" content="DG IT is a creative digital agency providing web development, digital marketing, video production, animation, and design services in Nepal at budget-friendly prices." />
        <meta name="keywords" content="web development, digital marketing, video ads, animation, logo design, Nepal, IT services" />
        <meta property="og:title" content="DG IT Pvt. Ltd. - Creative Digital Agency in Nepal" />
        <meta property="og:description" content="Get quality digital services including web development, marketing and design at budget-friendly prices." />
        <meta property="og:type" content="website" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://dgit.com.np/" />
      </Helmet>
      
      <Navbar />
      <main className="flex-grow">
        <Hero />
        <CoreServices />
        <WhyChooseUs />
        <Stats />
        <PortfolioOptimized />
        <HowWeWork />
        <Testimonials />
        <WeAreHiring />
        <Newsletter />
        <Contact />
      </main>
      <Footer />
      <BackToTopButton />
      <FloatingSocialButtons />
    </div>
  );
};

export default Index;
